var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithButton',{attrs:{"name":"create-group","title":"Crear nuevo grupo de precios","button_title":"Crear nuevo grupo"},on:{"cerrar":_vm.cerrar}},[_c('Form',{attrs:{"data":_vm.grupo},on:{"terminado":function($event){return _vm.crear()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }